import { Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { ExplainerCard } from "./ExplainerCard/ExplainerCard";
import type { ExplainerCardsProps } from "./types";

export const ExplainerCards = ({ ref, ...props }: ExplainerCardsProps) => {
  const { primary, secondary, className, ...otherProps } = props;

  const classes = classNames("mobius", "mobius-explainer-cards", className);

  return (
    <div ref={ref} className={classes} {...otherProps}>
      <section className="mobius-explainer-cards__section">
        <Text
          elementType="h2"
          variant="h2"
          className="mobius-explainer-cards__label"
        >
          Let&apos;s start with...
        </Text>
        <ExplainerCard productName={primary} isActionable />
      </section>
      {secondary && (
        <section className="mobius-explainer-cards__section">
          <Text
            elementType="h2"
            variant="h2"
            className="mobius-explainer-cards__label"
          >
            After that...
          </Text>
          <ExplainerCard
            productName={secondary}
            description={`${secondary} is quoted and paid separately, so we'll take care of that next.`}
            isActionable
            isDisabled
          />
        </section>
      )}
    </div>
  );
};

ExplainerCards.displayName = "ExplainerCards";
